$(".ImageSlider").owlCarousel({
  nav: true,
  dots: true,
  loop: true,
  autoplay: true,
  slideSpeed: 3000,
  margin: 15,
  responsiveClass: true,
  navText: ["<span>&#10229;</span>", "<span>&#10230;</span>"],
  responsive: {
    0: {
      items: 1,
    },
    470: {
      items: 1,
    },
    1200: {
      items: 1,
    },
  },
});
